<template>
  <section>
    <h2 class="heading-counter my-6">
      <span class="counter">3</span>Camp Prices
    </h2>
    <v-card class="global-card px-5 mt-10 pt-5">
      <v-card-text>
        <v-row class="transparent-field">
          <v-col sm="4" cols="12">
            <section class="increment-label">
              <span>Camp Price ( LE )</span>
              <number-input
                center
                placeholder="0"
                v-model="form.price"
                :min="0"
                controls
                :step="0.01"
              ></number-input>
            </section>
          </v-col>
          <v-col sm="4" cols="12">
            <v-switch
              inset
              v-model="form.online_payment"
              append-icon="icon-payment"
              label="Online Payment"
              color="success"
            ></v-switch>
            <!-- :label="`Switch 1: ${switch1.toString()}`" -->
          </v-col>
          <v-col sm="4" cols="12">
            <v-switch
              inset
              v-model="form.cashondelivery_payment"
              append-icon="icon-payment"
              label="Cash on Delivery"
              color="success"
            ></v-switch>
          </v-col>

          <!-- <v-col sm="4" cols="12">
            <v-switch
              v-model="form.has_bus"
              inset
              append-icon="icon-bus"
              label="Bus"
              color="success"
            ></v-switch>
            <v-row no-gutters>
              <v-col cols="9">
                <number-input
                  center
                  :value="0"
                  v-model="form.bus_price"
                  :step="0.01"
                  :min="0"
                  controls
                  :disabled="!form.has_bus"
                ></number-input>
              </v-col>

              <v-col cols="3" class="text-right">
                <v-btn
                  icon
                  color="primary"
                  class="tt-btn"
                  :disabled="!form.has_bus"
                  @click="dialog = true"
                  ><i class="icon-field-text"></i
                ></v-btn>
              </v-col>
            </v-row>
          </v-col> -->
          <v-col sm="4" cols="12">
            <v-switch
              v-model="form.has_bus"
              append-icon="icon-bus"
              label="Bus"
              inset
              color="success"
            ></v-switch>
            <v-row no-gutters>
              <v-col cols="9">
                <number-input
                  center
                  v-model="form.bus_price"
                  :min="0"
                  controls
                  :step="0.01"
                  :disabled="!form.has_bus"
                ></number-input>
              </v-col>

              <v-col cols="3" class="text-right">
                <v-btn
                  icon
                  color="primary"
                  class="tt-btn"
                  :disabled="!form.has_bus"
                  @click="mealDialog = true"
                  ><i class="icon-field-text"></i
                ></v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col sm="4" cols="12">
            <v-switch
              v-model="form.has_meals"
              append-icon="icon-meal"
              inset
              label="Meal"
              color="success"
            ></v-switch>
            <v-row no-gutters>
              <v-col cols="9">
                <number-input
                  center
                  v-model="form.meal_price"
                  :min="0"
                  controls
                  :step="0.01"
                  :disabled="!form.has_meals"
                ></number-input>
              </v-col>

              <v-col cols="3" class="text-right">
                <v-btn
                  icon
                  color="primary"
                  class="tt-btn"
                  :disabled="!form.has_meals"
                  @click="mealDialog = true"
                  ><i class="icon-field-text"></i
                ></v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col sm="4" cols="12">
            <v-switch
              v-model="form.has_photo"
              append-icon="icon-photo"
              inset
              label="Photos"
              color="success"
            ></v-switch>
            <v-row no-gutters>
              <v-col cols="9">
                <number-input
                  v-model="form.photos_price"
                  center
                  :min="0"
                  controls
                  :step="0.01"
                  :disabled="!form.has_photo"
                ></number-input>
              </v-col>

              <v-col cols="3" class="text-right">
                <v-btn
                  icon
                  color="primary"
                  class="tt-btn"
                  :disabled="!form.has_photo"
                  @click="photoDialog = true"
                  ><i class="icon-field-text"></i
                ></v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col sm="4" cols="12">
            <v-switch
              v-model="form.has_early_check_in"
              label="Early check in"
              inset
              append-icon="icon-checkin"
              color="success"
            ></v-switch>
            <v-row no-gutters>
              <v-col cols="9">
                <number-input
                  v-model="form.early_check_in_price"
                  center
                  :min="0"
                  controls
                  :step="0.01"
                  :disabled="!form.has_early_check_in"
                ></number-input>
              </v-col>
              <v-col cols="3" class="text-right">
                <v-btn
                  icon
                  color="primary"
                  class="tt-btn"
                  :disabled="!form.has_early_check_in"
                  @click="earlyDialog = true"
                  ><i class="icon-field-text"></i
                ></v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col sm="4" cols="12">
            <v-switch
              v-model="form.has_late_check_out"
              inset
              append-icon="icon-checkout"
              label="Late check out"
              color="success"
            ></v-switch>
            <v-row no-gutters>
              <v-col cols="9">
                <number-input
                  v-model="form.late_check_out_price"
                  center
                  controls
                  :step="0.01"
                  :disabled="!form.has_late_check_out"
                ></number-input>
              </v-col>
              <v-col cols="3" class="text-right">
                <v-btn
                  icon
                  color="primary"
                  class="tt-btn"
                  :disabled="!form.has_late_check_out"
                  @click="lateDialog = true"
                  ><i class="icon-field-text"></i
                ></v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col sm="4" cols="12">
            <v-switch
              v-model="form.has_special_needs"
              inset
              append-icon="icon-special-need"
              label="Has Special Needs"
              color="success"
            ></v-switch>
            <v-row no-gutters>
              <v-col cols="9">
                <number-input
                  center
                  v-model="form.special_needs_price"
                  controls
                  :step="0.01"
                  :disabled="!form.has_special_needs"
                ></number-input>
              </v-col>
              <v-col cols="3" class="text-right">
                <v-btn
                  icon
                  color="primary"
                  class="tt-btn"
                  :disabled="!form.has_special_needs"
                  @click="specialDialog = true"
                  ><i class="icon-field-text"></i
                ></v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <hr class="my-6" />
        <v-row>
          <v-col cols="12" class="py-0">
            <v-toolbar flat class="main-header px-0 mb-6">
              <v-toolbar-title class="main-header__title">
                <h2 class="heading-counter my-6">Discounts</h2>
              </v-toolbar-title>

              <v-spacer></v-spacer>
              <v-toolbar-items class="main-header__contents">
                <v-btn
                  class="button btn-height--1 my-auto mx-1"
                  @click="addDiscount"
                  color="success"
                  :disabled="addButtonCheck()"
                >
                  <i class="icon-add"></i>
                  <span class="mx-2">Add Discount</span>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
          </v-col>
          <v-col md="3" sm="6" cols="12">
            <v-select
              :items="discountItems"
              label="Discount"
              item-text="name"
              item-value="id"
              v-model="discounts.id"
              @change="discountsSelected()"
            ></v-select>
          </v-col>
          <v-col md="3" sm="6" cols="12">
            <section class="increment-label">
              <span>Discount Value</span>
              <number-input
                center
                v-model="discounts.value"
                :min="0"
                controls
                :step="0.01"
                :disabled="!activatedInputs"
              ></number-input>
            </section>
          </v-col>
          <v-col md="3" sm="6" cols="12">
            <v-select
              :items="valueType"
              item-text="text"
              item-value="text"
              label="Value Type"
              regular
              clearable
              v-model="discounts.value_type"
              :disabled="!activatedInputs"
            ></v-select>
          </v-col>
          <v-col md="3" sm="6" cols="12">
            <form-group name="expiry_date" :attribute="`fields.expiry_date`">
              <template slot-scope="{ attrs, listeners }">
                <date-time-picker
                  :listeners="listeners"
                  v-model.trim="discounts.expiry_date.date"
                  :date-time="discounts.expiry_date.date"
                  :textFieldProps="{ ...attrs, regular: true }"
                  timeFormat="HH:mm:ss"
                  :allowedDates="allowedDates"
                ></date-time-picker>
                <!-- :disabled="!activatedInputs" -->
              </template>
            </form-group>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="discounts_headers"
              :items="discounts_added"
              hide-default-footer
              :mobile-breakpoint="0"
              :items-per-page="150"
              class="table"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td class="text-sm-center">{{ item.name }}</td>
                  <td class="text-sm-center">{{ item.value }}</td>
                  <td class="text-sm-center">{{ item.value_type }}</td>
                  <td class="text-sm-center">
                    <span v-if="item.expiry_date !== ''">{{
                      item.expiry_date
                        ? item.expiry_date.date
                        : "---" | moment("Do MMM'YYYY hh:mm")
                    }}</span>
                    <span v-else>No Expiry Date</span>
                    <!-- <span v-if-else="isEdit === true && item.expiry_date === null"
                  >No Expiry Date</span
                > -->
                  </td>
                  <td class="text-sm-center">
                    <i
                      class="icon-delete delete"
                      @click="handleDelete(item)"
                    ></i>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" width="600px" persistent>
      <v-card>
        <v-card-title class="py-5 d-flex justify-space-between">
          <span class="headline"
            ><strong>{{ has_bus_locations_text }}</strong></span
          >
          <v-btn
            text
            color="primary"
            :disabled="busFormat"
            @click="busFormat = !busFormat"
            >Format</v-btn
          >
        </v-card-title>
        <v-card-text class="form-box">
          <small class="color-red"
            >* if you leave it empty when creating the camp, you will get
            'null'.</small
          >
          <section class="mt-6">
            <v-textarea
              v-if="!busFormat"
              regular
              label="Type here .."
              v-model="form.has_bus_locations_text"
            ></v-textarea>

            <vue-editor
              v-else
              v-model="form.has_bus_locations_text"
            ></vue-editor>
          </section>
          <!-- <textarea rows="5" regular v-model="form.has_bus_locations_text"></textarea> -->
        </v-card-text>
        <v-card-actions class="pa-5">
          <v-btn
            color="success "
            class="darken-1 px-12"
            rounded
            large
            :disabled="!form.has_bus_locations_text"
            @click="dialog = false"
            >Save</v-btn
          >
          <v-btn
            class="px-5"
            color="error"
            :disabled="!form.has_bus_locations_text"
            rounded
            large
            @click="cancelBus"
            >Clear</v-btn
          >
          <v-btn class="px-5" text large @click="cancelBus">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mealDialog" width="600px" persistent>
      <v-card>
        <v-card-title class="py-5 d-flex justify-space-between">
          <span class="headline"
            ><strong>{{ has_meals_text }}</strong></span
          >
          <v-btn
            text
            color="primary"
            :disabled="mealFormat"
            @click="mealFormat = !mealFormat"
            >Format</v-btn
          >
        </v-card-title>
        <v-card-text>
          <small class="color-red"
            >* if you leave it empty when creating the camp, you will get
            'null'.</small
          >
          <section class="mt-6">
            <v-textarea
              v-if="!mealFormat"
              regular
              label="Type here .."
              v-model="form.has_meals_text"
            ></v-textarea>

            <vue-editor v-else v-model="form.has_meals_text"></vue-editor>
          </section>
        </v-card-text>
        <v-card-actions class="pa-5">
          <v-btn
            color="success darken-1 px-12"
            rounded
            large
            @click="mealDialog = false"
            :disabled="!form.has_meals_text"
            >Save</v-btn
          >
          <v-btn
            class="px-5"
            color="error"
            :disabled="!form.has_meals_text"
            rounded
            large
            @click="cancelMeal"
            >Clear</v-btn
          >
          <v-btn class="px-5" text large @click="cancelMeal">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="photoDialog" width="600px" persistent>
      <v-card>
        <v-card-title class="py-5 d-flex justify-space-between">
          <span class="headline"
            ><strong>{{ has_photo_text }}</strong></span
          >
          <v-btn
            text
            color="primary"
            :disabled="photoFormat"
            @click="photoFormat = !photoFormat"
            >Format</v-btn
          >
        </v-card-title>
        <v-card-text>
          <small class="color-red"
            >* if you leave it empty when creating the camp, you will get
            'null'.</small
          >
          <section class="mt-6">
            <v-textarea
              v-if="!photoFormat"
              regular
              label="Type here .."
              v-model="form.has_photo_text"
            ></v-textarea>

            <vue-editor v-else v-model="form.has_photo_text"></vue-editor>
          </section>
        </v-card-text>
        <v-card-actions class="pa-5">
          <v-btn
            color="success darken-1 px-12"
            rounded
            large
            @click="photoDialog = false"
            :disabled="!form.has_photo_text"
            >Save</v-btn
          >
          <v-btn
            class="px-5"
            color="error"
            :disabled="!form.has_photo_text"
            rounded
            large
            @click="cancelPhoto"
            >Clear</v-btn
          >
          <v-btn class="px-5" text large @click="cancelPhoto">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="earlyDialog" width="600px" persistent>
      <v-card>
        <v-card-title class="py-5">
          <span class="headline"
            ><strong>{{ has_early_check_in_text }}</strong></span
          >
          <v-btn
            text
            color="primary"
            :disabled="earlyFormat"
            @click="earlyFormat = !earlyFormat"
            >Format</v-btn
          >
        </v-card-title>
        <v-card-text>
          <small class="color-red"
            >* if you leave it empty when creating the camp, you will get
            'null'.</small
          >
          <section class="mt-6">
            <v-textarea
              v-if="!earlyFormat"
              regular
              label="Type here .."
              v-model="form.has_early_check_in_text"
            ></v-textarea>

            <vue-editor
              v-else
              v-model="form.has_early_check_in_text"
            ></vue-editor>
          </section>
        </v-card-text>
        <v-card-actions class="pa-5">
          <v-btn
            color="success darken-1 px-12"
            rounded
            large
            @click="earlyDialog = false"
            :disabled="!form.has_early_check_in_text"
            >Save</v-btn
          >
          <v-btn
            class="px-5"
            color="error"
            :disabled="!form.has_early_check_in_text"
            rounded
            large
            @click="cancelEarly"
            >Clear</v-btn
          >
          <v-btn class="px-5" text large @click="cancelEarly">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="lateDialog" width="600px" persistent>
      <v-card>
        <v-card-title class="py-5 d-flex justify-space-between">
          <span class="headline"
            ><strong>{{ has_late_check_out_text }}</strong></span
          >
          <v-btn
            text
            color="primary"
            :disabled="lateFormat"
            @click="lateFormat = !lateFormat"
            >Format</v-btn
          >
        </v-card-title>
        <v-card-text>
          <small class="color-red"
            >* if you leave it empty when creating the camp, you will get
            'null'.</small
          >
          <section class="mt-6">
            <v-textarea
              v-if="!lateFormat"
              regular
              label="Type here .."
              v-model="form.has_late_check_out_text"
            ></v-textarea>

            <vue-editor
              v-else
              v-model="form.has_late_check_out_text"
            ></vue-editor>
          </section>
        </v-card-text>
        <v-card-actions class="pa-5">
          <v-btn
            color="success darken-1 px-12"
            rounded
            large
            @click="lateDialog = false"
            :disabled="!form.has_late_check_out_text"
            >Save</v-btn
          >
          <v-btn
            class="px-5"
            color="error"
            :disabled="!form.has_late_check_out_text"
            rounded
            large
            @click="cancelLate"
            >Clear</v-btn
          >
          <v-btn class="px-5" text large @click="cancelLate">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="specialDialog" width="600px" persistent>
      <v-card>
        <v-card-title class="py-5 d-flex justify-space-between">
          <span class="headline"
            ><strong>{{ has_special_needs_text }}</strong></span
          >
          <v-btn
            text
            color="primary"
            :disabled="needsFormat"
            @click="needsFormat = !needsFormat"
            >Format</v-btn
          >
        </v-card-title>
        <v-card-text class="form-box">
          <small class="color-red"
            >* if you leave it empty when creating the camp, you will get
            'null'.</small
          >
          <section class="mt-6">
            <v-textarea
              v-if="!needsFormat"
              regular
              label="Type here .."
              v-model="form.has_special_needs_text"
            ></v-textarea>

            <vue-editor
              v-else
              v-model="form.has_special_needs_text"
            ></vue-editor>
          </section>
        </v-card-text>
        <v-card-actions class="pa-5">
          <v-btn
            color="success darken-1 px-12"
            rounded
            large
            @click="specialDialog = false"
            :disabled="!form.has_special_needs_text"
            >Save</v-btn
          >
          <v-btn
            class="px-5"
            color="error"
            :disabled="!form.has_special_needs_text"
            rounded
            large
            @click="cancelNeeds"
            >Clear</v-btn
          >
          <v-btn class="px-5" text large @click="cancelNeeds">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import {
  IndexData
  // StoreData,
  // ShowData,
  // UpdateData
} from "@/helpers/apiMethods";
import TableHeaders from "@/helpers/TableHeaders";
import { VueEditor } from "vue2-editor";

export default {
  data() {
    return {
      discountItems: [],
      // prices: [
      //   {
      //     icon: "",
      //     label: "Bus",
      //     toggle: "has_bus",
      //     number_model: "bus_price"
      //   },
      //   {
      //     icon: "",
      //     label: "Meal",
      //     toggle: "has_meals",
      //     number_model: "meal_price"
      //   }
      // ],
      activatedInputs: null,
      valueType: [{ text: "amount" }, { text: "percentage" }],
      discounts_added: [],
      discounts_headers: [],
      menu1: false,
      dialog: false,
      busFormat: false,
      mealDialog: false,
      mealFormat: false,
      photoDialog: false,
      photoFormat: false,
      earlyDialog: false,
      earlyFormat: false,
      lateDialog: false,
      lateFormat: false,
      needsFormat: false,
      specialDialog: false,
      has_bus_locations_text: "Bus Description",
      has_meals_text: "Meals Description",
      has_photo_text: "Photos Description",
      has_early_check_in_text: "Early Check-in Description",
      has_late_check_out_text: "Late Check-out Description",
      has_special_needs_text: "Special Needs Description"
    };
  },
  components: {
    DateTimePicker: () => import("@/components/DateTimePicker"),
    VueEditor
  },
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    discounts: {
      type: Object,
      default: () => {}
    },
    discoutsItems: {
      type: Array,
      default: () => {}
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.indexDiscounts();
    this.createTableHeaders();
    // setTimeout(() => {
    //   if (this.isEdit === true) {
    //     this.discounts_added = this.discoutsItems;
    //   }
    // }, 500);
  },
  methods: {
    indexDiscounts() {
      IndexData({ reqName: `/discounts` })
        .then(res => {
          const { data } = res.data;
          this.discountItems = data;
          // this.discountItems = data.map(el => {
          //   return {
          //     name: el.name,
          //     id: el.id
          //   };
          // });
        })
        .catch(() => {})
        .finally(() => {});
    },
    addDiscount() {
      console.log("dsdf");
      this.discounts_added.push(this.discounts);
      this.$emit("handle_discounts_added", this.discounts_added);
      this.$emit("handle_reset_discount");
    },
    allowedDates(value) {
      const previesDate = new Date(value);
      const currentDate = new Date(
        new Date().setDate(new Date().getDate() - 1)
      );
      return previesDate > currentDate;
    },
    addButtonCheck() {
      if (this.discounts.id === null) {
        return true;
      } else {
        return false;
      }
    },
    createTableHeaders() {
      const headersList = [
        "Discount",
        "Value",
        "Value Type",
        "Expiry Date",
        "Discard"
      ];
      this.discounts_headers = TableHeaders(headersList);
    },
    discountsSelected() {
      const discount = this.discounts.id;
      this.discountItems.forEach(item => {
        if (item.id === discount) {
          console.log(item);

          this.discounts.value = item.value;
          this.discounts.name = item.name;
          this.discounts.value_type = item.value_type;
          this.activatedInputs = item.allow_camp_modify;
        }
      });
    },
    handleDelete(item) {
      const index = this.discounts_added.indexOf(item);
      this.$delete(this.discounts_added, index);
      // this.discounts_added.splice(index, 1);
      this.discountItems.push(item);
      console.log(item);
    },
    cancelBus() {
      this.dialog = false;
      this.form.has_bus_locations_text = "";
    },
    cancelMeal() {
      this.mealDialog = false;
      this.form.has_meals_text = "";
    },
    cancelPhoto() {
      this.photoDialog = false;
      this.form.has_photo_text = "";
    },
    cancelEarly() {
      this.earlyDialog = false;
      this.form.has_early_check_in_text = "";
    },
    cancelLate() {
      this.lateDialog = false;
      this.form.has_late_check_out_text = "";
    },
    cancelNeeds() {
      this.specialDialog = false;
      this.form.has_special_needs_text = "";
    }
  },
  watch: {
    discoutsItems: {
      handler(value) {
        this.discounts_added = value;
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
